/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Link16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M3.418 6.179a.503.503 0 11.711.711L3.037 7.983a3.524 3.524 0 000 4.98 3.525 3.525 0 004.98 0l1.093-1.092a.503.503 0 01.711.711L8.73 13.675a4.531 4.531 0 01-6.404 0 4.53 4.53 0 010-6.404zm7.262-.88l.068.057a.508.508 0 010 .712l-4.98 4.98a.509.509 0 01-.712 0 .508.508 0 010-.712l4.98-4.98a.51.51 0 01.644-.057zm2.995-2.974a4.53 4.53 0 010 6.404L12.582 9.82a.503.503 0 01-.711-.711l1.092-1.093a3.524 3.524 0 000-4.98 3.525 3.525 0 00-4.98 0L6.89 4.129a.503.503 0 11-.711-.711L7.27 2.325a4.531 4.531 0 016.404 0z"
        />
    </AccessibleSVG>
);

export default Link16;
